// components/ui/Spinner.js
import React from "react";

export default function Spinner({ size = 24, className = "" }) {
  return (
    <div
      className={`inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <div
        className="border-2 border-current rounded-full animate-spin"
        style={{
          width: size * 0.8,
          height: size * 0.8,
          borderTopColor: 'transparent',
          borderRightColor: 'transparent',
          animationDuration: '1s',
          animationTimingFunction: 'linear'
        }}
      />
    </div>
  );
}
